
import type {
  AddWalletOperationTypeReq,
  BaseErrorResponse,
  EmptySuccessResponse,
  GetWalletOperationTypeRes,
  GetWalletOperationTypesRes,
  UpdateWalletOperationTypeReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useWalletOperationType() {
  class WalletOperationType<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Wallet operation type
     * @name WalletOperationTypeControllerGetWalletOperationTypes
     * @summary Getting a wallet operation types
     * @request GET:/api3/wallet-operation-type
     * @secure
     * @response `200` `GetWalletOperationTypesRes`
     * @response `400` `BaseErrorResponse`
     */
    walletOperationTypeControllerGetWalletOperationTypes = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
        /** @example {"filter":[{"field":"id","value":"1","operation":"="},{"field":"id","value":"2","operation":"="}]} */
        filter?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetWalletOperationTypesRes, BaseErrorResponse>({
        path: '/api3/wallet-operation-type',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Wallet operation type
     * @name WalletOperationTypeControllerCreateWalletOperationType
     * @summary Create a wallet operation type
     * @request POST:/api3/wallet-operation-type
     * @secure
     * @response `200` `GetWalletOperationTypeRes`
     * @response `400` `BaseErrorResponse`
     */
    walletOperationTypeControllerCreateWalletOperationType = (
      data: AddWalletOperationTypeReq,
      params: RequestParams = {},
    ) =>
      this.request<GetWalletOperationTypeRes, BaseErrorResponse>({
        path: '/api3/wallet-operation-type',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Wallet operation type
     * @name WalletOperationTypeControllerUpdateWalletOperationType
     * @summary Update a wallet operation type
     * @request PUT:/api3/wallet-operation-type/{id}
     * @secure
     * @response `200` `GetWalletOperationTypeRes`
     * @response `400` `BaseErrorResponse`
     */
    walletOperationTypeControllerUpdateWalletOperationType = (
      id: number,
      data: UpdateWalletOperationTypeReq,
      params: RequestParams = {},
    ) =>
      this.request<GetWalletOperationTypeRes, BaseErrorResponse>({
        path: `/api3/wallet-operation-type/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Wallet operation type
     * @name WalletOperationTypeControllerDeleteWalletOperationType
     * @summary Delete a wallet operation type
     * @request DELETE:/api3/wallet-operation-type/{id}
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    walletOperationTypeControllerDeleteWalletOperationType = (id: number, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/api3/wallet-operation-type/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new WalletOperationType();
}
